import axios from 'axios';
import { RoleModel } from '../../pages/catalogos/roles/models/RoleModel';

const API_URL = process.env.REACT_APP_API;

export async function obtenerRolesService(): Promise<RoleModel[]> {
  try {
    const response = await axios.get(`${API_URL}users/roles`);
    const data = response.data.doc.data;
    return data.rows ?? data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function obtenerRolPorIdService(id: number): Promise<RoleModel> {
  try {
    const response = await axios.get(`${API_URL}users/roles/${id}`);
    return response.data.doc.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function guardarRolService(rol: RoleModel): Promise<any> {
  try {
    const { id, name, code, description } = rol;
    const payload = { name, code, description: description ?? null };
    if (id) {
      return await axios.put(`${API_URL}users/roles/${id}`, payload);
    } else {
      return await axios.post(`${API_URL}users/roles`, payload);
    }
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function eliminarRolService(id: number): Promise<any> {
  try {
    return await axios.delete(`${API_URL}users/roles/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
}
